import { render } from "./HeroiconsSolidPuzzle.vue?vue&type=template&id=3614886c"
const script = {}

import exportComponent from "/var/www/web/driving-school-be/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidPuzzle.vue"]])

export default __exports__